import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { AccountDao } from '@app/dao/account/account.dao';
import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { SimulationType } from '@app/dao/simulation/simulation.interface';
import { Subject } from 'rxjs';
import { EaSimulationFiscalityRentFormBuilder } from './ea-simulation-fiscality-rent-form.builder';

@Component({
    selector: 'ea-simulation-fiscality-rent-form',
    templateUrl: './ea-simulation-fiscality-rent-form.component.html',
    styleUrls: ['./ea-simulation-fiscality-rent-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaSimulationFiscalityRentFormComponent),
        },
    ],
    standalone: false
})
export class EaSimulationFiscalityRentFormComponent
  extends EaSimulationFiscalityRentFormBuilder
  implements OnInit
{
  doneSubject: Subject<void> = new Subject<void>();
  account: any;
  fiscalityType: string[];
  defaultValueSelect: string;

  constructor(
    protected formConstructor: PrFormConstructor,
    private accountDao: AccountDao,
    private simulationDao: SimulationDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.accountDao.getAccount().subscribe(account => {
      this.account = account;
    });
    this.fiscalityType = [
      'FONCIER',
      'MICRO_FONCIER',
      'BIC',
      'MICRO_BIC',
      'MICRO_BIC_TOURISME_CLASSE',
      'MICRO_BIC_TOURISME_NON_CLASSE',
    ];
  }

  onSubmit() {
    this.prFormService.loading();
    this.simulationDao
      .simulate(null, SimulationType.FISCALITY_RENT, this.extract())
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          if (this.callback) this.callback(success);
          this.notificationService.success('La simulation a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La simulation a échoué');
        },
      );
  }

  get inCash() {
    return this.form.get('cashOrCredit').value == 'CASH';
  }
}
